
const palette = {
    primary: {
        main: "#00749e",
        divider: "#CCC"
    },
    secondary: {
        main: "#000"
    },
    error: {
        main: "#B3282D"
    },
    warning: {
        main: "#FFD554"
    },
    background: {
        default: "#F6F7FB"
    },
}

export default palette